import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';

import Icon from '../Icon';

const Input = styled.input`
  width: 100%;
  border-radius: ${({ theme }) => theme.baseBorderRadius};
  color: ${({ theme }) => theme.textColor};
  font-size: ${rem(14)};
  font-family: ${({ theme }) => theme.fontFamily};
  outline: 0;
  background-color: #fff;
  border-radius: ${({ theme }) => theme.borderRadius};
  height: ${rem(52)};
  padding: ${rem(20)};
  ${props => {
    const { theme } = props;
    if (props.border) {
      return `
      border: ${rem(2)} solid ${
        props.error ? theme.color.danger : theme.color.separator
      } !important;
      `;
    }
  }}
  appearance: none;
  font-family: 'Roboto', sans-serif;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'auto')};
  &::placeholder {
    color: ${({ theme }) => theme.color.font.secondary};
  }
`;

const Wrapper = styled.div`
  position: relative;
`;

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  right: ${rem(15)};
  transform: translateY(-50%);
  line-height: 0;
`;

const Error = styled.span`
  color: ${({ theme }) => theme.color.danger};
`;

class CompInput extends PureComponent {
  render() {
    if (this.props.type !== 'radio') {
      return (
        <Wrapper>
          <Input
            {...this.props}
            border={this.props.border}
            innerRef={this.props.inputRef}
            haveIcon={!!this.props.icon}
            id={this.props.id || this.context.id}
          />
          {this.props.icon && <StyledIcon name={this.props.icon} />}
          {this.props.error && <Error>{this.props.error}</Error>}
        </Wrapper>
      );
    }
    return (
      <input
        {...this.props}
        style={{display: 'inline-block'}}
        id={this.props.id || this.context.id}
        type="radio"
      />
    );
  }
}

CompInput.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string,
  inputRef: PropTypes.func,
};

CompInput.defaultProps = {
  id: null,
  icon: null,
  inputRef: () => {},
};

CompInput.contextTypes = {
  id: PropTypes.string,
};

export default CompInput;



// WEBPACK FOOTER //
// ./src/components/Input/index.js